import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AppUpdateService } from '../../../core/services/app-update/app-update.service';

@Component({
  selector: 'app-app-update-banner',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div
      *ngIf="updateAvailable$ | async"
      class="font-onest fixed !w-[50%] mx-auto bottom-4 left-0 right-0 z-[70] justify-between px-4 py-3 flex w-full items-center justify-center gap-4 bg-foreground py-2 text-background border border-border rounded-2xl shadow-lg"
      role="alert"
    >
      <div>
        <h4 class="text-sm font-medium text-background">
          A new version of the app is available.
        </h4>
        <p class="text-xs text-background/80">
          Refresh to get the latest changes.
        </p>
      </div>
      <button
        type="button"
        class="rounded-full text-sm px-3 py-2 font-medium transition-colors bg-background text-foreground border border-border"
        (click)="reload()"
      >
        Refresh
      </button>
    </div>
  `,
})
export class AppUpdateBannerComponent {
  private readonly appUpdateService = inject(AppUpdateService);

  readonly updateAvailable$ = this.appUpdateService.updateAvailable$;

  reload(): void {
    this.appUpdateService.reload();
  }
}
